// permission
import { useCheckPermissions, useUserInfo } from 'hooks';
// utils
import { getData } from 'utils/storage';

export const useCheckBrokerPermissions = (permissions = []) => {
  const impersonateData = getData('impersonate');
  const { userInfo } = useUserInfo();

  const passed = useCheckPermissions(permissions);

  if (
    userInfo?.isImpersonating &&
    impersonateData?.impersonateType?.toLowerCase() === 'member'
  ) {
    return passed;
  }

  return false;
};
